import { z } from 'zod';
export const BroadcastMessageType = z.enum(['TICKET', 'CERTIFICATE']);
export const BroadcastChannel = z.enum(['email']);
export const BroadcastFilter = z.object({
    modality: z.enum(['VIRTUAL', 'PRESENCIAL']).optional(),
    onlyPending: z.boolean().default(true),
    eventId: z.string().uuid(),
});
export const BroadcastRequest = z.object({
    messageType: BroadcastMessageType,
    channel: BroadcastChannel,
    filter: BroadcastFilter,
});
export const BroadcastProgressEvent = z.object({
    attendeeId: z.string().uuid(),
    status: z.enum(['sent', 'failed', 'skipped']),
    messageId: z.string().optional(),
    error: z.string().optional(),
    progress: z.object({
        done: z.number().int().nonnegative(),
        total: z.number().int().nonnegative(),
    }),
});
//# sourceMappingURL=broadcast.js.map